import { render } from "./TenantAppUpdateConfigsManagement.vue?vue&type=template&id=704d1729"
import script from "./TenantAppUpdateConfigsManagement.vue?vue&type=script&lang=js"
export * from "./TenantAppUpdateConfigsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__